import React from "react";
import { Link } from "react-router-dom";

// Logo Lokapp (lockup horizontal officiel, identique au site lokapp.fr).
// `href` absolu => lien classique, sinon navigation interne.
export default function Brand({ href = "/", className = "" }) {
    const classes = `lk-brand ${className}`.trim();
    const image = <img src="/logo-full.png" alt="Lokapp" />;

    if (/^https?:\/\//.test(href)) {
        return (
            <a className={classes} href={href} aria-label="Lokapp">
                {image}
            </a>
        );
    }

    return (
        <Link className={classes} to={href} aria-label="Lokapp - accueil">
            {image}
        </Link>
    );
}
